export default __webpack_public_path__ + "static/media/services-bg.b2af9f0b.png";